export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '爆料热榜', href: '#ranking' },
        { label: '最新快讯', href: '#updates' },
        { label: '深度爆料', href: '#cards' },
        { label: '精彩视频', href: '#media' },
      ],
    },
    {
      title: '特色专栏',
      links: [
        { label: '专题合集', href: '#index' },
        { label: '热门话题', href: '#topics' },
        { label: '焦点专题', href: '#carousel' },
        { label: '吃瓜评论', href: '#comments' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '关于黑料', href: '#about' },
        { label: '平台优势', href: '#features' },
        { label: '常见问题', href: '#faq' },
        { label: '下载App', href: '#app' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12 mb-12">
          <div className="sm:col-span-2">
            <a href="#hero" className="inline-block no-underline mb-4">
              <span className="font-heading text-2xl font-bold text-primary-600">黑料</span>
              <span className="ml-2 text-xs text-foreground-500 font-label">每日吃瓜爆料第一站</span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-[360px]">
              集合黑料吃瓜、每日爆料视频与黑料社区互动，提供官网最新入口、黑料不打烊在线观看及app下载服务，追踪娱乐圈内幕真相。
            </p>
            <div className="flex items-center gap-3">
              <a href="#app" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-smartphone-line"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer no-underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 pt-8 mb-8">
          <h4 className="font-label text-sm font-semibold text-foreground-700 mb-4">
            合作伙伴
          </h4>
          <div className="flex flex-wrap items-center gap-6">
            <span className="text-sm text-foreground-400">虚位以待，诚邀合作</span>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黑料 每日吃瓜爆料视频与黑料社区。本站为娱乐资讯聚合平台，所有内容仅供参考。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>黑料</span>
            <span>·</span>
            <span>黑料社区</span>
            <span>·</span>
            <span>黑料不打烊</span>
          </div>
        </div>
      </div>
    </footer>
  );
}